"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPhoneSubmitBody = exports.getEmailSubmitBody = void 0;
var getEmailSubmitBody = function (_a, newEmail) {
    var oldEmail = _a.emailAddress;
    var body = {};
    if (newEmail !== oldEmail) {
        body.emailAddress = newEmail;
    }
    return body;
};
exports.getEmailSubmitBody = getEmailSubmitBody;
var getPhoneSubmitBody = function (_a, newPhoneNumbers) {
    var oldPhoneNumbers = _a.phoneNumbers;
    var body = {};
    if (JSON.stringify(newPhoneNumbers) !== JSON.stringify(oldPhoneNumbers)) {
        body.phoneNumbers = newPhoneNumbers;
    }
    return body;
};
exports.getPhoneSubmitBody = getPhoneSubmitBody;
